import type { CrmIntegrationConversation } from '../types/crm-integration-chat.types'
import type { CrmIntegrationMessage } from '../types/crm-integration-chat.types'
import { mapCrmIntegrationMessages } from './mapCrmIntegrationMessage'
import type { CrmIntegrationMessageView } from '../types/crm-integration-message.types'

export type ParsedCrmIntegrationMessagesPayload = {
  conversation: CrmIntegrationConversation | null
  items: CrmIntegrationMessageView[]
}

export const parseCrmIntegrationMessagesPayload = (
  data: unknown,
): ParsedCrmIntegrationMessagesPayload => {
  const empty: ParsedCrmIntegrationMessagesPayload = {
    conversation: null,
    items: [],
  }

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return empty
  }

  const record = data as Record<string, unknown>
  const rawItems = Array.isArray(record.items)
    ? (record.items as CrmIntegrationMessage[])
    : []

  const conversationRaw = record.conversation
  const conversation =
    conversationRaw != null &&
    typeof conversationRaw === 'object' &&
    !Array.isArray(conversationRaw)
      ? (conversationRaw as CrmIntegrationConversation)
      : null

  return {
    conversation,
    items: mapCrmIntegrationMessages(rawItems),
  }
}
